require('@global/Polyfills/index')
window._ = require('lodash');
window.dayjs = require('dayjs')
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
require('@app/Lib/FontAwsome');
